export default __webpack_public_path__ + "static/media/sign.852a0aac.avif";